import { Alert, Link as StormLink } from '@amzn/storm-ui';
import styled from 'styled-components';
import { BANNER_LEVEL, BANNER_TYPE } from 'src/app/slice';

export const OverrideModalZIndex = (theme) => ({
  ...theme,
  modal: {
    ...theme.modal,
    zIndex: 1002,
  },
});

export const PageBannerContainer = styled.div<{
  isFocusLayout: boolean;
}>`
  ${({ theme, isFocusLayout }) =>
    isFocusLayout
      ? `padding: ${theme.spacing.base} 20px;`
      : `padding: ${theme.spacing.base} 20px 0 20px;
       margin-bottom: ${theme.spacing.base};`}
`;

export const Link = styled(StormLink)<{
  bannerType?: BANNER_TYPE;
  bannerLevel: BANNER_LEVEL;
}>`
  && {
    color: ${({ theme, bannerLevel, bannerType }) =>
      bannerLevel === BANNER_LEVEL.CONSOLE
        ? bannerType === BANNER_TYPE.WARNING
          ? theme.palette.inkwell
          : theme.palette.white
        : theme.palette.blue[700]};
  }
`;

export const TruncatedTextWrapper = styled.div`
  display: grid;
  grid-template-columns: auto min-content;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: center;
`;

export const TruncatedText = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BannerText = styled.div`
  display: inline;
`;

export const StyledAlert = styled(Alert)`
  max-width: 100%;
`;
